import { ToolsRoute } from './routes/tools-route.js';
import { ToolsReculRoute } from './routes/tools-recul-route.js';
import { ToolsWhoRoute } from './routes/tools-who-route.js';
import { PracticeDoneRoute } from './routes/practice-done-route.js';

/** Tools: the athlete's (ruled 16 October) and a parent's (ruled 1 November). */
export const toolsRoutes = [
  { path: 'tools', element: <ToolsRoute /> },
  /* A parent's child picker (board R7). */
  { path: 'tools/who', element: <ToolsWhoRoute /> },
  /* Recul from Tools, no lesson (stage 4), then its Done screen (board R3). */
  { path: 'tools/recul', element: <ToolsReculRoute /> },
  { path: 'tools/practice/:practiceId', element: <PracticeDoneRoute /> },
];
